import {useIntl} from 'react-intl'
import {NavLink, useLocation} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {useEffect} from 'react'
import {ROUTES} from '../../../../_gori/constants'
import {NavDropdownCardItem} from './NavDropdownCardItem'

export function Header() {
  const intl = useIntl()
  const BASE_DOMAIN = process.env.REACT_APP_DOMAIN
  const {pathname} = useLocation()

  const toggleProducts = () => {
    const dd = document.getElementById('products-dropdown-desktop')
    dd?.classList.toggle('d-none')
    dd?.classList.toggle('d-flex')
  }

  const toggleMobileProducts = () => {
    const dd = document.getElementById('products-dropdown-mobile')
    dd?.classList.toggle('show')
  }

  const closeDTProductDropdown = () => {
    const dd = document.getElementById('products-dropdown-desktop')
    if (dd?.classList.contains('d-flex')) {
      dd.classList.remove('d-flex')
      dd.classList.add('d-none')
    }
  }

  const closeMobileProductDropdown = () => {
    const mobileDd = document.getElementById('products-dropdown-mobile')
    if (mobileDd?.classList.contains('show')) {
      mobileDd.classList.remove('show')
    }
  }

  const toggleResources = () => {
    const dd = document.getElementById('resources-dropdown-desktop')
    dd?.classList.toggle('d-none')
    dd?.classList.toggle('d-flex')
  }

  const toggleMobileResources = () => {
    const dd = document.getElementById('resources-dropdown-mobile')
    dd?.classList.toggle('show')
  }

  const closeDTResourceDropdown = () => {
    const dd = document.getElementById('resources-dropdown-desktop')
    if (dd?.classList.contains('d-flex')) {
      dd.classList.remove('d-flex')
      dd.classList.add('d-none')
    }
  }

  const closeMobileResourceDropdown = () => {
    const mobileDd = document.getElementById('resources-dropdown-mobile')
    if (mobileDd?.classList.contains('show')) {
      mobileDd.classList.remove('show')
    }
  }

  useEffect(() => {
    const productActive = pathname.includes('products')
    const resourceActive =
      pathname.includes('blog') ||
      pathname.includes('releases') ||
      pathname.includes('shipping-calculators') ||
      pathname.includes('usps-zone-map')
    const productsLinkItem = document.querySelector('.products-container .nav-link')
    const resourcesLinkItem = document.querySelector('.resources-container .nav-link')
    const mobileProdDd = document.getElementById('products-dropdown-mobile')
    const mobileResDd = document.getElementById('resources-dropdown-mobile')

    if (productActive) {
      productsLinkItem?.classList.add('active')
    }

    if (resourceActive) {
      resourcesLinkItem?.classList.add('active')
    }

    const handleCollapse = () => {
      if (pathname && pathname.includes('products') && !mobileProdDd?.classList.contains('show')) {
        toggleMobileProducts()
      }
      if (
        pathname &&
        (pathname.includes('blog') || pathname.includes('releases')) &&
        !mobileResDd?.classList.contains('show')
      ) {
        toggleMobileResources()
      }
    }

    document.addEventListener('shown.bs.collapse', handleCollapse)

    return () => {
      document.removeEventListener('shown.bs.collapse', handleCollapse)
    }
  }, [pathname])

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const productDropdown = document.getElementById('products-dropdown-desktop')
      const mobileProductDropdown = document.getElementById('products-dropdown-mobile')
      const resourceDropdown = document.getElementById('resources-dropdown-desktop')
      const mobileResourceDropdown = document.getElementById('resources-dropdown-mobile')

      if (
        productDropdown &&
        !productDropdown.contains(event.target) &&
        !event.target.closest('.products-container')
      ) {
        closeDTProductDropdown()
      }

      if (
        mobileProductDropdown &&
        !mobileProductDropdown.contains(event.target) &&
        !event.target.closest('.products-container-mobile')
      ) {
        closeMobileProductDropdown()
      }

      if (
        resourceDropdown &&
        !resourceDropdown.contains(event.target) &&
        !event.target.closest('.resources-container')
      ) {
        closeDTResourceDropdown()
      }

      if (
        mobileResourceDropdown &&
        !mobileResourceDropdown.contains(event.target) &&
        !event.target.closest('.resources-container-mobile')
      ) {
        closeMobileResourceDropdown()
      }
    }

    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        closeDTProductDropdown()
        closeMobileProductDropdown()
        closeDTResourceDropdown()
        closeMobileResourceDropdown()
      }
    }

    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('keydown', handleEscKey)

    return () => {
      document.removeEventListener('click', handleOutsideClick)
      document.removeEventListener('keydown', handleEscKey)
    }
  }, [])

  const products = [
    {
      key: 'product',
      path: ROUTES.PRODUCTS.PRODUCT,
      icon: '/media/gori/header-icon/store.svg',
      description: intl.formatMessage({id: 'PRODUCT_DESC_SHIPBAE'}),
      label: (
        <>
          {intl.formatMessage({id: 'SHIPBAE'})}
          <sup className='service-mark'>SM</sup>
        </>
      ),
    },
    {
      key: 'insurance',
      path: ROUTES.PRODUCTS.INSURANCE,
      icon: '/media/gori/header-icon/baeguard.svg',
      description: intl.formatMessage({id: 'PRODUCT_DESC_BAEGUARD'}),
      label: (
        <>
          {intl.formatMessage({id: 'BAEGUARD'})}
          <sup className='service-mark'>SM</sup>
        </>
      ),
    },
    // Wait for the release of the actual page before adding these to the header dropdown
    // {
    //   key: 'gori-api',
    //   path: 'https://gori.ai/gori-api/',
    //   icon: '/media/gori/header-icon/api.svg',
    //   description: intl.formatMessage({id: 'PRODUCT_DESC_GORI_API'}),
    //   external: true,
    //   label: (
    //     <>
    //       {intl.formatMessage({id: 'GORI_API'})}
    //       <sup className='service-mark'>SM</sup>
    //     </>
    //   ),
    // },
    // {
    //   key: 'shipbae-a1',
    //   path: ROUTES.PRODUCTS.SHIPBAE_A1,
    //   icon: '/media/gori/header-icon/a1.svg',
    //   description: intl.formatMessage({id: 'PRODUCT_DESC_SHIPBAE_A1'}),
    //   label: (
    //     <>
    //       {intl.formatMessage({id: 'SHIPBAE_A1'})}
    //       <sup className='service-mark'>SM</sup>
    //     </>
    //   ),
    // },
    {
      key: 'gori-signature',
      path: ROUTES.PRODUCTS.GORI_SIGNATURE_PAGE,
      icon: '/media/gori/header-icon/gori-signature.svg',
      description: intl.formatMessage({id: 'PRODUCT_DESC_GORI_SIGNATURE'}),
      label: (
        <>
          {intl.formatMessage({id: 'GORI_SIGNATURE'})}
          <sup className='service-mark'>SM</sup>
        </>
      ),
    },
    // {
    //   key: 'bae',
    //   path: ROUTES.PRODUCTS.BAE,
    //   icon: '/media/gori/header-icon/bae.svg',
    //   description: intl.formatMessage({id: 'PRODUCT_DESC_BAE'}),
    //   label: (
    //     <>
    //       {intl.formatMessage({id: 'BAE'})}
    //       <sup className='service-mark'>SM</sup>
    //     </>
    //   ),
    // },
  ]

  const resources = [
    {
      key: 'blog',
      path: ROUTES.RESOURCE.BLOG,
      icon: '/media/gori/header-icon/blog.svg',
      description: intl.formatMessage({id: 'RESOURCE_DESC_BLOG'}),
      label: intl.formatMessage({id: 'BLOG'}),
    },
    {
      key: 'releases',
      path: ROUTES.RESOURCE.RELEASES,
      icon: '/media/gori/header-icon/release.svg',
      description: intl.formatMessage({id: 'RESOURCE_DESC_RELEASES'}),
      label: intl.formatMessage({id: 'RELEASES'}),
    },
    {
      key: 'help-center',
      path: ROUTES.HELP_CENTER.BASE,
      icon: '/media/gori/header-icon/help-center.svg',
      description: intl.formatMessage({id: 'RESOURCE_DESC_HELP_CENTER'}),
      label: intl.formatMessage({id: 'HELP_CENTER'}),
      external: true,
    },
    {
      key: 'shipping-calculators',
      path: ROUTES.RESOURCE.SHIPPING_CALCULATORS,
      icon: '/media/gori/header-icon/shipping-calculators.svg',
      description: intl.formatMessage({id: 'RESOURCE_DESC_SHIPPING_CALCULATORS'}),
      label: intl.formatMessage({id: 'SHIPPING_CALCULATORS'}),
    },
    {
      key: 'usps-zone-map',
      path: ROUTES.RESOURCE.USPS_ZONE_MAP,
      icon: '/media/gori/header-icon/usps-zone-map.svg',
      description: intl.formatMessage({id: 'RESOURCE_DESC_ZONE_MAP'}),
      label: intl.formatMessage({id: 'USPS_ZONE_MAP'}),
    },
  ]

  return (
    <header className='public-header'>
      <nav className='navbar navbar-expand-lg navbar-light bg-white fixed-top border-bottom shadow-sm navbar-custom-expand'>
        <div className='container'>
          {/* Logo */}
          <NavLink to='/' className='navbar-brand p-0'>
            <img
              alt='ShipBae Powered By Gori.ai'
              src={toAbsoluteUrl('/media/logos/shipbae-gori-logo.svg')}
            />
          </NavLink>

          {/* Hamburger button */}
          <button
            className='navbar-toggler border-0'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarCollapse'
            aria-controls='navbarCollapse'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button>

          {/* Collapsible Menu */}
          <div className='collapse navbar-collapse mt-5 nav-mt-0' id='navbarCollapse'>
            {/* Left side links */}
            <ul className='navbar-nav align-items-center me-auto mb-2 nav-mb-0'>
              {/* Mobile Products Dropdown */}
              <li className='nav-item nav-mobile products-container-mobile position-relative'>
                <button
                  className='nav-link py-2 nav-py-0 px-0 btn btn-link text-start'
                  onClick={toggleMobileProducts}
                >
                  {intl.formatMessage({id: 'PRODUCTS'})}
                  <img
                    className='ms-2 d-inline-block'
                    src='/media/gori/arrows/arrow_down.svg'
                    alt='down-chevron'
                  />
                </button>
                <div
                  id='products-dropdown-mobile-container'
                  className='integration-dropdown-menu-container'
                >
                  <ul
                    id='products-dropdown-mobile'
                    className='integration-dropdown-menu nav flex-nowrap list-unstyled flex-column mx-auto'
                  >
                    {products.map((product) => (
                      <NavDropdownCardItem
                        key={product.key}
                        path={product.path}
                        icon={product.icon}
                        description={product.description}
                        label={product.label}
                        onClick={toggleMobileProducts}
                        compact
                      />
                    ))}
                  </ul>
                </div>
              </li>

              {/* Mobile Integrations */}
              <li className='nav-item nav-mobile'>
                <NavLink to={ROUTES.INTEGRATIONS.BASE} className='nav-link py-2 nav-py-0 px-0'>
                  {intl.formatMessage({id: 'INTEGRATION'})}
                </NavLink>
              </li>

              {/* Mobile Resources Dropdown */}
              <li className='nav-item nav-mobile resources-container-mobile position-relative'>
                <button
                  className='nav-link py-2 nav-py-0 px-0 btn btn-link text-start'
                  onClick={toggleMobileResources}
                >
                  {intl.formatMessage({id: 'RESOURCES'})}
                  <img
                    className='ms-2 d-inline-block'
                    src='/media/gori/arrows/arrow_down.svg'
                    alt='down-chevron'
                  />
                </button>
                <div
                  id='resources-dropdown-mobile-container'
                  className='integration-dropdown-menu-container'
                >
                  <ul
                    id='resources-dropdown-mobile'
                    className='integration-dropdown-menu nav flex-nowrap list-unstyled flex-column mx-auto'
                  >
                    {resources.map((resource) => (
                      <NavDropdownCardItem
                        key={resource.key}
                        path={resource.path}
                        icon={resource.icon}
                        description={resource.description}
                        label={resource.label}
                        onClick={toggleMobileResources}
                        compact
                      />
                    ))}
                  </ul>
                </div>
              </li>

              {/* Desktop Products Dropdown */}
              <li className='nav-item nav-desktop products-container position-relative'>
                <button
                  className='nav-link py-2 nav-py-0 px-0 btn btn-link p-0'
                  onClick={toggleProducts}
                >
                  {intl.formatMessage({id: 'PRODUCTS'})}
                  <img
                    className='ms-2 d-inline-block'
                    src='/media/gori/arrows/arrow_down.svg'
                    alt='down-chevron'
                  />
                </button>
                <ul
                  id='products-dropdown-desktop'
                  className='nav-dropdown-card-menu d-none nav flex-nowrap list-unstyled position-absolute bg-white border rounded shadow-sm p-5 z-3 mt-5'
                >
                  <li className='nav-dropdown-card-menu__title'>
                    {intl.formatMessage({id: 'PRODUCTS'})}
                  </li>
                  {products.map((product) => (
                    <NavDropdownCardItem
                      key={product.key}
                      path={product.path}
                      icon={product.icon}
                      description={product.description}
                      label={product.label}
                      onClick={toggleProducts}
                    />
                  ))}
                </ul>
              </li>

              {/* Desktop Pricing */}
              <li className='nav-item nav-desktop'>
                <NavLink to={'/pricing'} className='nav-link py-2 nav-py-0 px-0'>
                  {intl.formatMessage({id: 'PRICING'})}
                </NavLink>
              </li>

              {/* Desktop Integrations */}
              <li className='nav-item nav-desktop'>
                <NavLink to={ROUTES.INTEGRATIONS.BASE} className='nav-link py-2 nav-py-0 px-0'>
                  {intl.formatMessage({id: 'INTEGRATION'})}
                </NavLink>
              </li>

              {/* Desktop Resources Dropdown */}
              <li className='nav-item nav-desktop resources-container position-relative'>
                <button
                  className='nav-link py-2 nav-py-0 px-0 btn btn-link p-0'
                  onClick={toggleResources}
                >
                  {intl.formatMessage({id: 'RESOURCES'})}
                  <img
                    className='ms-2 d-inline-block'
                    src='/media/gori/arrows/arrow_down.svg'
                    alt='down-chevron'
                  />
                </button>
                <ul
                  id='resources-dropdown-desktop'
                  className='nav-dropdown-card-menu d-none nav flex-nowrap list-unstyled position-absolute bg-white border rounded shadow-sm p-5 z-3 mt-5'
                >
                  <li className='nav-dropdown-card-menu__title'>
                    {intl.formatMessage({id: 'RESOURCES'})}
                  </li>
                  {resources.map((resource) => (
                    <NavDropdownCardItem
                      key={resource.key}
                      path={resource.path}
                      icon={resource.icon}
                      description={resource.description}
                      label={resource.label}
                      onClick={toggleResources}
                    />
                  ))}
                </ul>
              </li>

              {/* Mobile Pricing */}
              <li className='nav-item nav-mobile'>
                <NavLink to={'/pricing'} className='nav-link py-2 nav-py-0 px-0'>
                  {intl.formatMessage({id: 'PRICING'})}
                </NavLink>
              </li>
            </ul>

            {/* Right Side Buttons */}
            <ul className='navbar-nav align-items-center mb-2 nav-mb-0'>
              <li className='nav-item py-2 nav-py-0'>
                <NavLink
                  to={ROUTES.AUTH.BASE}
                  className='btn btn-advanced-secondary fs-4 fw-boldest text-capitalize rounded-pill py-3 px-6'
                >
                  {intl.formatMessage({id: 'LOG_IN'})}
                </NavLink>
              </li>

              <li className='nav-item nav-ms-3 mt-2 nav-mt-0 py-2 nav-py-0'>
                <a
                  className='btn btn-outline btn-primary-deep darker hover-orange fs-4 fw-boldest text-capitalize rounded-pill py-3 px-6'
                  href={`${document.location.protocol}//${BASE_DOMAIN}${ROUTES.AUTH.REGISTRATION}`}
                >
                  {intl.formatMessage({id: 'START_FREE'})}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  )
}
